<template>
  <svg width="30" height="20" viewBox="0 0 30 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
    <path
      d="M10.9706 4.82435C10.9706 7.01454 9.3464 8.7173 7.42783 8.7173C5.50926 8.7173 3.88505 7.01454 3.88505 4.82435C3.88505 2.63416 5.50926 0.931396 7.42783 0.931396C9.3464 0.931396 10.9706 2.63416 10.9706 4.82435ZM7.42783 11.3647C8.28871 11.3647 9.10696 11.1656 9.84544 10.8155H10.2578C12.2869 10.8155 14.0027 12.6178 14.0027 14.9281V16.3558C14.0027 17.0291 13.5092 17.5032 12.9867 17.5032H1.86901C1.34646 17.5032 0.852966 17.0291 0.852966 16.3558V14.9281C0.852966 12.6178 2.56877 10.8155 4.59788 10.8155H5.01062C5.75092 11.1653 6.56626 11.3647 7.42783 11.3647Z"
      fill="#3377DD"
      stroke="white"
      :class="containerClass"
    />
    <path
      d="M26.4679 4.82435C26.4679 7.01454 24.8437 8.7173 22.9251 8.7173C21.0066 8.7173 19.3824 7.01454 19.3824 4.82435C19.3824 2.63416 21.0066 0.931396 22.9251 0.931396C24.8437 0.931396 26.4679 2.63416 26.4679 4.82435ZM22.9251 11.3647C23.786 11.3647 24.6043 11.1656 25.3428 10.8155H25.7551C27.7842 10.8155 29.5 12.6178 29.5 14.9281V16.3558C29.5 17.0291 29.0065 17.5032 28.484 17.5032H17.3663C16.8438 17.5032 16.3503 17.0291 16.3503 16.3558V14.9281C16.3503 12.6178 18.0661 10.8155 20.0952 10.8155H20.5079C21.2482 11.1653 22.0636 11.3647 22.9251 11.3647Z"
      fill="#3377DD"
      stroke="white"
      :class="containerClass"
    />
    <path
      d="M18.0455 6.82117C18.0455 9.01136 16.4213 10.7141 14.5027 10.7141C12.5841 10.7141 10.9599 9.01136 10.9599 6.82117C10.9599 4.63098 12.5841 2.92822 14.5027 2.92822C16.4213 2.92822 18.0455 4.63098 18.0455 6.82117ZM14.5027 13.3615C15.3636 13.3615 16.1818 13.1624 16.9203 12.8124H17.3326C19.3617 12.8124 21.0775 14.6146 21.0775 16.925V18.3527C21.0775 19.0259 20.5841 19.5 20.0615 19.5H8.94386C8.42131 19.5 7.92782 19.0259 7.92782 18.3527V16.925C7.92782 14.6146 9.64362 12.8124 11.6727 12.8124H12.0855C12.8258 13.1621 13.6411 13.3615 14.5027 13.3615Z"
      fill="#3377DD"
      stroke="white"
      :class="containerClass"
    />
  </svg>
</template>

<script>
export default {
  props: {
    className: {
      type:  [String, Array],
      default: "",
    },
    containerClass: {
      type: String,
      default: "",
    },
  },
};
</script>
